import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	users: [],
	isLoading: false,
	error: false,
};

const usersSlice = createSlice({
	name: 'users',
	initialState,
	reducers: {
		storeUsers: (state, action) => {
			state.users = action.payload;
		},
	},
});

export const selectAllUsers = (state) => {
	return state.users;
};

export const { storeUsers } = usersSlice.actions;

export default usersSlice.reducer;
